const indexItems = [
  { letter: 'A', name: '爱豆动态', desc: '明星行程、机场路透、日常分享', count: '328篇' },
  { letter: 'B', name: '八卦爆料', desc: '独家内幕、圈内秘闻、关系网深扒', count: '256篇' },
  { letter: 'C', name: '吃瓜前线', desc: '实时热点、全民热议、梗图合集', count: '412篇' },
  { letter: 'D', name: '电视剧集', desc: '热播剧评、剧情解析、大结局讨论', count: '189篇' },
  { letter: 'E', name: '二次元圈', desc: '动漫新番、漫展资讯、同人创作', count: '145篇' },
  { letter: 'F', name: '粉丝文化', desc: '应援活动、粉丝经济、站子动态', count: '167篇' },
  { letter: 'G', name: '搞笑段子', desc: '娱乐圈趣事、综艺名场面、鬼畜', count: '298篇' },
  { letter: 'H', name: '话题热榜', desc: '每日热搜、话题排行、趋势分析', count: '534篇' },
  { letter: 'I', name: '影视资讯', desc: '新片上映、票房数据、影评精选', count: '221篇' },
];

const letterColors = [
  'bg-primary-100 text-primary-700',
  'bg-accent-100 text-accent-700',
  'bg-secondary-100 text-secondary-700',
  'bg-primary-100 text-primary-700',
  'bg-accent-100 text-accent-700',
  'bg-secondary-100 text-secondary-700',
  'bg-primary-100 text-primary-700',
  'bg-accent-100 text-accent-700',
  'bg-secondary-100 text-secondary-700',
];

export default function SectionGroupC() {
  return (
    <>
      <section id="contact" className="py-14 md:py-20 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-1 h-6 rounded-full bg-primary-500"></div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">联系我们</h2>
            <span className="text-xs text-foreground-400 ml-2">投稿与合作</span>
          </div>
          <div className="bg-background-100 rounded-2xl border border-background-200/70 p-8 md:p-12">
            <div className="max-w-2xl mx-auto text-center">
              <div className="w-16 h-16 rounded-2xl bg-primary-100 flex items-center justify-center mx-auto mb-6">
                <i className="ri-mail-send-line text-2xl text-primary-500 w-6 h-6 flex items-center justify-center"></i>
              </div>
              <h3 className="text-xl font-heading font-bold text-foreground-900 mb-4">欢迎投稿与商务合作</h3>
              <p className="text-foreground-600 leading-relaxed mb-8 text-sm md:text-base">
                如果你有独家爆料、深度内容或商务合作意向，欢迎通过以下方式联系我们。51黑料网期待与更多优质内容创作者、品牌方和媒体机构建立长期合作，共同打造更丰富的娱乐资讯生态。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                <div className="flex items-center gap-2 px-5 py-3 bg-background-50 rounded-xl border border-background-200/70">
                  <i className="ri-mail-line text-primary-500 w-4 h-4 flex items-center justify-center"></i>
                  <span className="text-sm text-foreground-700">contact@51heiliao.com</span>
                </div>
                <div className="flex items-center gap-2 px-5 py-3 bg-background-50 rounded-xl border border-background-200/70">
                  <i className="ri-wechat-line text-primary-500 w-4 h-4 flex items-center justify-center"></i>
                  <span className="text-sm text-foreground-700">51黑料官方微信</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="about" className="py-14 md:py-20 bg-background-100">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-1 h-6 rounded-full bg-accent-500"></div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">关于我们</h2>
            <span className="text-xs text-foreground-400 ml-2">品牌介绍</span>
          </div>
          <div className="bg-background-50 rounded-2xl border border-background-200/70 p-8 md:p-12">
            <div className="max-w-3xl mx-auto">
              <div className="text-center mb-8">
                <span className="text-3xl font-heading font-bold text-primary-500">51黑料</span>
                <p className="text-foreground-500 text-sm mt-2">国内领先的娱乐资讯聚合平台</p>
              </div>
              <div className="space-y-4 text-foreground-600 leading-relaxed text-sm md:text-base">
                <p>
                  51黑料网创立于对娱乐资讯传播方式的深度思考之上。我们观察到，在信息爆炸的时代，用户获取高质量娱乐资讯的成本越来越高——碎片化、同质化、真假难辨的内容充斥各大平台。51黑料网站的使命，就是通过专业的内容筛选与聚合机制，为用户提供一站式的优质娱乐资讯服务。
                </p>
                <p>
                  作为51黑料官网的核心入口，51黑料网页版无需下载安装，打开浏览器即可访问全部功能。平台涵盖明星动态、影视综艺、音乐演出、体育赛事、社会热点等多个垂直领域，每天实时更新数百条精选内容。51黑料网入口的设计理念是"简单即高效"——用户无需复杂操作，通过51黑料官网地址即可快速触达核心栏目和热门内容。
                </p>
                <p>
                  我们拥有一支经验丰富的内容运营团队，结合智能算法与人工审核，确保每一条资讯都经过严格筛选。51黑料吃瓜入口汇集全网热议话题，让用户不错过任何一个精彩瞬间。未来，51黑料将继续深耕娱乐资讯领域，为用户带来更快、更全、更优质的吃瓜体验。
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="index" className="py-14 md:py-20 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-1 h-6 rounded-full bg-primary-500"></div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">主题索引</h2>
            <span className="text-xs text-foreground-400 ml-2">内容分类</span>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {indexItems.map((item, i) => (
              <div
                key={i}
                className="bg-background-100 rounded-xl p-5 border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer flex items-start gap-4 group"
              >
                <div className={`w-10 h-10 rounded-lg flex items-center justify-center font-heading font-bold text-lg ${letterColors[i]} flex-shrink-0`}>
                  {item.letter}
                </div>
                <div className="min-w-0">
                  <h3 className="text-base font-heading font-bold text-foreground-900 mb-1 group-hover:text-primary-500 transition-colors">{item.name}</h3>
                  <p className="text-xs text-foreground-500 mb-2">{item.desc}</p>
                  <span className="text-[10px] text-foreground-400 bg-background-200 px-2 py-0.5 rounded-full">{item.count}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}